import {deviceType} from './deviceType'
export default{
    appData(){
        if(deviceType.isAndroidApp){
            try {
                return JSON.parse(window.app_android_interface.getUserInfo());
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
            console.log('IOS')
        }
    },
    appAskDoctor(data){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.askDoctor(JSON.stringify(data));
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
            console.log('IOS')
        }
    },
    appOpenMiniProgram(data){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.openMiniProgram(JSON.stringify(data));
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
            console.log('IOS')
        }
    },
    appCloseLoadingView(){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.closeLoadingView();
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
            console.log('IOS')
        }
    },
    appIsLogin(){
        if(deviceType.isAndroidApp){
            try {
                return window.app_android_interface.isLogin();
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
            console.log('IOS')
        }else{
            return true;
        }
    }

}